import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Inicio";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Appointments from "@/pages/Appointments";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-mute">Cargando...</div>;
  return user ? children : <Navigate to="/admin/login" replace />;
};

export default function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/nosotros" element={<About />} />
              <Route path="/citas" element={<Appointments />} />
              <Route path="/opiniones" element={<Reviews />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/testimonios" element={<Testimonials />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" position="top-center" offset={88} richColors />
      </AuthProvider>
    </SiteProvider>
  );
}
